import { useMemo } from 'react';
import { useFlightDeckContext } from '@atlassiansox/flight-deck-frontend-client';
import { FD_CLIENT_FETCH_PROPS } from '../../../hydrator-config-client';
import { createActivityClient } from '../../index';
export var useActivityClient = function useActivityClient(version, product, logger, baseUrl) {
  var _useFlightDeckContext = useFlightDeckContext(),
    getArtifact = _useFlightDeckContext.getArtifact;
  return useMemo(function () {
    return createActivityClient(version, product, logger, baseUrl,
    // If the rw-client is wrapped in a FD provider, use the provided fetch function
    getArtifact ? function () {
      return getArtifact(FD_CLIENT_FETCH_PROPS.name, FD_CLIENT_FETCH_PROPS.dimensions);
    } : undefined);
  }, [version, product, logger, baseUrl, getArtifact]);
};